import * as React from "react";
import { forwardRef } from "react";
const SvgDriver = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", id: "Capa_1", x: "0px", y: "0px", viewBox: "0 0 512 512", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", width: 512, height: 512, ref, ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#CEE1F2"
}, d: "M80,256c0-122.365,88.168-219.927,206-234.196C276.194,20.616,266.184,20,256,20\n		C123.452,20,20,123.452,20,256s103.452,236,236,236c10.184,0,20.194-0.616,30-1.804C168.168,475.927,80,378.365,80,256z" }), /* @__PURE__ */ React.createElement("circle", { style: {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, cx: 256, cy: 256, r: 236 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M107.673,196c40.624,0,256.022,0,296.652,0C411.852,214.533,416,234.791,416,256c0,88.223-71.777,160-160,160S96,344.223,96,256\n		S167.777,96,256,96c28.058,0,54.452,7.26,77.403,20" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M410.938,296H376c-44.183,0-80,35.817-80,80v34.938" }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, d: "\n		M216,410.938V376c0-44.183-35.817-80-80-80h-34.938" }), /* @__PURE__ */ React.createElement("line", { style: {
  fill: "none",
  stroke: 0,
  strokeWidth: 40,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, x1: 256, y1: 276, x2: 256, y2: 276 })));
const ForwardRef = forwardRef(SvgDriver);
export { ForwardRef as ReactComponent };
